import { createContext, useState } from "react";

export const MapContext = createContext(null);

export function MapContextProvider({ children, value }) {
    
    return (
        <MapContext.Provider
            value={value}
        >
            {children}
        </MapContext.Provider>
    );
}
